export default __webpack_public_path__ + "static/media/detail_mobile_2_3.c781ef69.png";